import { SESSION_TOKEN_URL } from '../../../NonReact/constants/ApiConstants'
import { SessionTokenResponse } from '../../../NonReact/Types/Types'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

const TIMEOUT_IN_MS: number = 4000

export const getTokenForSession = (): Promise<Nullable<string>> =>
    requestGetJSON<SessionTokenResponse>(SESSION_TOKEN_URL, { timeout: TIMEOUT_IN_MS }).then(
        (response: JSONResponse<SessionTokenResponse>) => response?.authToken
    )
